import { useUserStore } from '@/stores';
import type { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';

interface RequestConfig {
  unsetAuthorization?: boolean;
}
interface IInternalRequestConfig extends RequestConfig, InternalAxiosRequestConfig {}

export default (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(
    async (config: IInternalRequestConfig) => {
      if (!config?.unsetAuthorization) {
        const { token } = useUserStore();
        if (token) {
          config.headers.Authorization = 'Bearer ' + token;
        }
      }
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );
};